/**
 * ScanFilterBar Component
 * Filter bar for scans with date range picker
 */

import React from 'react';
import { DatePicker } from 'antd';
import { colors, spacing } from '../../../theme/designTokens';

const { RangePicker } = DatePicker;

function ScanFilterBar({ dateRange, onDateRangeChange }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: spacing.md,
      }}
    >
      <span style={{ fontWeight: 500, color: colors.text.primary, whiteSpace: 'nowrap' }}>
        Scan Date Range:
      </span>
      <RangePicker
        value={dateRange}
        onChange={onDateRangeChange}
        style={{ width: 320 }}
        format="YYYY-MM-DD"
        placeholder={['Start Date', 'End Date']}
      />
    </div>
  );
}

export default ScanFilterBar;
